import useFetch from './useFetch';

const useGet = <T>(url: string, options: RequestInit = {}) => {
  const { data, error, isLoading, fetchData } = useFetch<T>(url, {
    ...options,
    method: 'GET',
  });

  return { data, error, isLoading, fetchData };
};

export default useGet;